import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import "./SpellTemplate.scss";
import SpellTemplateFull from "../../components/spell/SpellTemplateFull";
import SpellTemplateUpdate from "../../components/spell/SpellTemplateUpdate";
import SpellTemplateDelete from "../../components/spell/SpellTemplateDelete";

const SpellTemplate = () => {
  const { idSpellTemplate } = useParams();
  const [spellTemplate, setSpellTemplate] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setIsUpdate(false);
    setIsDelete(false);
    setRefresh(false);
    setTimeout(() => {
      api
        .get(`/spelltemplate/${idSpellTemplate}/`)
        .then((response) => {
          setSpellTemplate(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }, 500);
  }, [refresh]);

  return (
    <div className="spell-template">
      {isLoading && (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      )}
      {!isLoading && spellTemplate == null && (
        <div className="no-data">
          <p>
            <strong>Sort introuvable</strong>
          </p>
        </div>
      )}
      {!isLoading && spellTemplate && (
        <>
          {isUpdate && (
            <>
              <SpellTemplateUpdate
                spellTemplate={spellTemplate}
                setIsUpdate={setIsUpdate}
                setRefresh={setRefresh}
              />
            </>
          )}

          {isDelete && (
            <>
              <SpellTemplateDelete
                spellTemplate={spellTemplate}
                setIsDelete={setIsDelete}
              />
            </>
          )}

          {!isUpdate && !isDelete && (
            <>
              <SpellTemplateFull
                spellTemplate={spellTemplate}
                setIsUpdate={setIsUpdate}
                setIsDelete={setIsDelete}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SpellTemplate;
